import React, { useState, useEffect } from "react";
import { Spinner } from "@lemonadetraining/web-ui";
import { notifyActions, NOTIFICATION_TYPE } from "@lemonadetraining/web-shared";
import { useDispatch, useSelector } from "react-redux";
import { AnimatePresence } from "motion/react";
import ViewScoreItem from "./ViewScoreItem";
import WidgetCard from "../Cards/WidgetCard";
import { loadWorkoutResults } from "@lemonadetraining/web-shared";

const ViewAthletesScoresWidget = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const [Loading, setLoading] = useState(true);
  const [scores, setScores] = useState([]);

  useEffect(
    (scores) => {
      const loadScores = async () => {
        await loadWorkoutResults(props.workoutCardUID, user.uid)
          .then((data) => {
            setScores(data.data);
          })
          .catch((err) => {
            const notification = {
              severity: NOTIFICATION_TYPE.error,
              title: "Reading workout score error",
              message: err.message,
            };
            dispatch(notifyActions.sendNotification(notification));
          });
        setLoading(false);
      };

      loadScores();
    },
    [props.workoutCardUID]
  );

  return (
    <WidgetCard title="Athletes Scores">
      {Loading && <Spinner className="my-5 h-6 w-6" />}
      <AnimatePresence>
        {scores.length > 0 &&
          scores.map((eachScore, idx) => (
            <ViewScoreItem key={idx} idx={idx} score={eachScore.data} />
          ))}
      </AnimatePresence>
    </WidgetCard>
  );
};

export default ViewAthletesScoresWidget;
